import { memo } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import FullScreenMessage from 'src/view/components/FullScreenMessage/FullScreenMessage';

const OrderNotSelectedMessage: React.FC = (): JSX.Element => {
  return <FullScreenMessage withoutIcon message={localeStore.t('order_not_selected')} messageClassName="family-bold text-size-36 color-gray2" />;
};

export default memo(OrderNotSelectedMessage);
